import { useSyncExternalStore } from "react";

export const LANGS = [
  { code: "it", label: "Italiano", flag: "/flags/it.svg" },
  { code: "en", label: "English", flag: "/flags/gb.svg" },
  { code: "es", label: "Español", flag: "/flags/es.svg" },
  { code: "fr", label: "Français", flag: "/flags/fr.svg" },
  { code: "de", label: "Deutsch", flag: "/flags/de.svg" },
];

const SUPPORTED = LANGS.map((l) => l.code);

function detect() {
  try {
    const saved = localStorage.getItem("rr-lang");
    if (saved && SUPPORTED.includes(saved)) return saved;
  } catch (e) {
    console.warn("i18n: localStorage non disponibile", e);
  }
  const nav = (navigator.language || "it").slice(0, 2).toLowerCase();
  return SUPPORTED.includes(nav) ? nav : "it";
}

let current = detect();
const listeners = new Set();

export function getLang() {
  return current;
}

export function setLang(code) {
  if (!SUPPORTED.includes(code)) return;
  current = code;
  try {
    localStorage.setItem("rr-lang", code);
  } catch (e) {
    console.warn("i18n: localStorage non disponibile", e);
  }
  listeners.forEach((f) => f());
}

export function useLang() {
  return useSyncExternalStore(
    (f) => {
      listeners.add(f);
      return () => listeners.delete(f);
    },
    getLang
  );
}

const TR = {
  it: {
    consultMenu: "Consulta il Menu",
    subtitle: "Caffetteria · Pasticceria · Cocktail Bar",
    tagline: "L'eleganza di un rito quotidiano, nel cuore di Messina.",
    ourMenu: "Il Nostro Menu",
    cocktailCarte: "La Carta dei Cocktail",
    cocktailSub: "Ricette classiche e creazioni della casa",
    searchPh: "Cerca: cappuccino, pistacchio, Mojito…",
    resultsFor: "Risultati per",
    noResults: "Nessun prodotto trovato. Prova con un altro termine.",
    loading: "Il menu sta arrivando…",
    loadingShort: "Caricamento…",
    items: "proposte",
    otherCats: "Altre categorie",
    otherCocktails: "Altre carte cocktail",
    empty: "La selezione sarà presto disponibile.",
    preparation: "Preparazione",
    garnish: "Guarnizione",
    notFound: "Categoria non trovata.",
    backToMenu: "Torna al menu",
    cadNote: "cad.",
    cocktailPricing1: "Cocktail base € 8,00",
    cocktailPricing2: "Cocktail con stuzzicheria varia € 15,00",
    privacyLink: "Privacy & Cookie Policy",
    privacyTitle: "Informativa Privacy e Cookie",
    privacyControllerTitle: "Titolare del trattamento",
    privacyControllerBody: "Ritrovo Rinascente — Via dei Mille 240/242, Messina · Tel. 090 6019495 · P.IVA: IT3531300832",
    privacyPurposeTitle: "Finalità del sito / web app",
    privacyPurposeBody: "Questa applicazione web è un menu digitale destinato alla consultazione dei prodotti, dei prezzi e degli allergeni. Non raccoglie dati personali a fini commerciali né esegue profilazione degli utenti.",
    privacyCookieTitle: "Cookie Policy",
    privacyCookieBody: "Utilizziamo esclusivamente cookie tecnici o di memorizzazione locale (Local Storage/Session Storage) necessari al corretto funzionamento della piattaforma (ad esempio la memorizzazione della lingua selezionata). Non vengono utilizzati cookie di terze parti o di profilazione pubblicitaria. Non è richiesto alcun tracciamento invasivo.",
    privacyRightsTitle: "Diritti dell'utente (GDPR UE 2016/679)",
    privacyRightsBody: "Per qualsiasi informazione relativa alla sicurezza dei dati o al funzionamento del servizio, il cliente può rivolgersi direttamente al titolare dell'attività presso il locale.",
    privacyClose: "Chiudi",
  },
  en: {
    consultMenu: "View the Menu",
    subtitle: "Coffee · Pastry · Cocktail Bar",
    tagline: "The elegance of a daily ritual, in the heart of Messina.",
    ourMenu: "Our Menu",
    cocktailCarte: "The Cocktail List",
    cocktailSub: "Classic recipes and house creations",
    searchPh: "Search: cappuccino, pistachio, Mojito…",
    resultsFor: "Results for",
    noResults: "No items found. Try another term.",
    loading: "The menu is on its way…",
    loadingShort: "Loading…",
    items: "items",
    otherCats: "Other categories",
    otherCocktails: "More cocktail lists",
    empty: "The selection will be available soon.",
    preparation: "Preparation",
    garnish: "Garnish",
    notFound: "Category not found.",
    backToMenu: "Back to menu",
    cadNote: "each",
    cocktailPricing1: "Classic cocktails € 8.00",
    cocktailPricing2: "Cocktail with assorted nibbles € 15.00",
    privacyLink: "Privacy & Cookie Policy",
    privacyTitle: "Privacy & Cookie Notice",
    privacyControllerTitle: "Data Controller",
    privacyControllerBody: "Ritrovo Rinascente — Via dei Mille 240/242, Messina, Italy · Tel. +39 090 6019495 · VAT no.: IT3531300832",
    privacyPurposeTitle: "Purpose of this website / web app",
    privacyPurposeBody: "This web application is a digital menu for browsing products, prices and allergens. It does not collect personal data for commercial purposes and does not profile users.",
    privacyCookieTitle: "Cookie Policy",
    privacyCookieBody: "We only use technical cookies or local storage (Local Storage/Session Storage) required for the platform to work properly (for example, remembering the selected language). No third-party or advertising profiling cookies are used. No invasive tracking is required.",
    privacyRightsTitle: "Your rights (EU GDPR 2016/679)",
    privacyRightsBody: "For any information about data security or how the service works, customers may contact the business owner directly at the venue.",
    privacyClose: "Close",
  },
  es: {
    consultMenu: "Ver la Carta",
    subtitle: "Cafetería · Pastelería · Bar de Cócteles",
    tagline: "La elegancia de un ritual cotidiano, en el corazón de Mesina.",
    ourMenu: "Nuestra Carta",
    cocktailCarte: "La Carta de Cócteles",
    cocktailSub: "Recetas clásicas y creaciones de la casa",
    searchPh: "Buscar: capuchino, pistacho, Mojito…",
    resultsFor: "Resultados para",
    noResults: "No se encontraron productos. Prueba con otro término.",
    loading: "La carta está llegando…",
    loadingShort: "Cargando…",
    items: "propuestas",
    otherCats: "Otras categorías",
    otherCocktails: "Más cartas de cócteles",
    empty: "La selección estará disponible pronto.",
    preparation: "Preparación",
    garnish: "Guarnición",
    notFound: "Categoría no encontrada.",
    backToMenu: "Volver a la carta",
    cadNote: "c/u",
    cocktailPricing1: "Cóctel clásico 8,00 €",
    cocktailPricing2: "Cóctel con aperitivos variados 15,00 €",
    privacyLink: "Privacidad y Cookies",
    privacyTitle: "Política de Privacidad y Cookies",
    privacyControllerTitle: "Responsable del tratamiento",
    privacyControllerBody: "Ritrovo Rinascente — Via dei Mille 240/242, Mesina · Tel. 090 6019495 · NIF: IT3531300832",
    privacyPurposeTitle: "Finalidad del sitio / aplicación web",
    privacyPurposeBody: "Esta aplicación web es una carta digital destinada a la consulta de productos, precios y alérgenos. No recoge datos personales con fines comerciales ni elabora perfiles de los usuarios.",
    privacyCookieTitle: "Política de Cookies",
    privacyCookieBody: "Utilizamos exclusivamente cookies técnicas o almacenamiento local (Local Storage/Session Storage) necesarios para el correcto funcionamiento de la plataforma (por ejemplo, guardar el idioma seleccionado). No se utilizan cookies de terceros ni de perfilado publicitario. No se requiere ningún seguimiento invasivo.",
    privacyRightsTitle: "Derechos del usuario (RGPD UE 2016/679)",
    privacyRightsBody: "Para cualquier información sobre la seguridad de los datos o el funcionamiento del servicio, el cliente puede dirigirse directamente al titular de la actividad en el local.",
    privacyClose: "Cerrar",
  },
  fr: {
    consultMenu: "Voir la Carte",
    subtitle: "Café · Pâtisserie · Bar à Cocktails",
    tagline: "L'élégance d'un rituel quotidien, au cœur de Messine.",
    ourMenu: "Notre Carte",
    cocktailCarte: "La Carte des Cocktails",
    cocktailSub: "Recettes classiques et créations maison",
    searchPh: "Rechercher : cappuccino, pistache, Mojito…",
    resultsFor: "Résultats pour",
    noResults: "Aucun produit trouvé. Essayez un autre terme.",
    loading: "La carte arrive…",
    loadingShort: "Chargement…",
    items: "propositions",
    otherCats: "Autres catégories",
    otherCocktails: "Autres cartes cocktails",
    empty: "La sélection sera bientôt disponible.",
    preparation: "Préparation",
    garnish: "Garniture",
    notFound: "Catégorie introuvable.",
    backToMenu: "Retour à la carte",
    cadNote: "pièce",
    cocktailPricing1: "Cocktail classique 8,00 €",
    cocktailPricing2: "Cocktail avec amuse-bouches variés 15,00 €",
    privacyLink: "Confidentialité & Cookies",
    privacyTitle: "Politique de Confidentialité et de Cookies",
    privacyControllerTitle: "Responsable du traitement",
    privacyControllerBody: "Ritrovo Rinascente — Via dei Mille 240/242, Messine · Tél. 090 6019495 · N° TVA : IT3531300832",
    privacyPurposeTitle: "Finalité du site / de l'application web",
    privacyPurposeBody: "Cette application web est une carte digitale destinée à la consultation des produits, des prix et des allergènes. Elle ne collecte aucune donnée personnelle à des fins commerciales et n'effectue aucun profilage des utilisateurs.",
    privacyCookieTitle: "Politique de Cookies",
    privacyCookieBody: "Nous utilisons exclusivement des cookies techniques ou le stockage local (Local Storage/Session Storage) nécessaires au bon fonctionnement de la plateforme (par exemple la mémorisation de la langue choisie). Aucun cookie tiers ou de profilage publicitaire n'est utilisé. Aucun suivi invasif n'est requis.",
    privacyRightsTitle: "Droits de l'utilisateur (RGPD UE 2016/679)",
    privacyRightsBody: "Pour toute information relative à la sécurité des données ou au fonctionnement du service, le client peut s'adresser directement au titulaire de l'activité sur place.",
    privacyClose: "Fermer",
  },
  de: {
    consultMenu: "Menü ansehen",
    subtitle: "Kaffee · Konditorei · Cocktailbar",
    tagline: "Die Eleganz eines täglichen Rituals im Herzen von Messina.",
    ourMenu: "Unsere Karte",
    cocktailCarte: "Die Cocktailkarte",
    cocktailSub: "Klassische Rezepte und Kreationen des Hauses",
    searchPh: "Suchen: Cappuccino, Pistazie, Mojito…",
    resultsFor: "Ergebnisse für",
    noResults: "Keine Produkte gefunden. Versuchen Sie einen anderen Begriff.",
    loading: "Die Karte wird geladen…",
    loadingShort: "Laden…",
    items: "Einträge",
    otherCats: "Weitere Kategorien",
    otherCocktails: "Weitere Cocktailkarten",
    empty: "Die Auswahl wird in Kürze verfügbar sein.",
    preparation: "Zubereitung",
    garnish: "Garnitur",
    notFound: "Kategorie nicht gefunden.",
    backToMenu: "Zurück zur Karte",
    cadNote: "pro Stk.",
    cocktailPricing1: "Cocktail klassisch 8,00 €",
    cocktailPricing2: "Cocktail mit verschiedenen Snacks 15,00 €",
    privacyLink: "Datenschutz & Cookies",
    privacyTitle: "Datenschutz- und Cookie-Richtlinie",
    privacyControllerTitle: "Verantwortlicher",
    privacyControllerBody: "Ritrovo Rinascente — Via dei Mille 240/242, Messina · Tel. 090 6019495 · USt-IdNr.: IT3531300832",
    privacyPurposeTitle: "Zweck der Website / Web-App",
    privacyPurposeBody: "Diese Webanwendung ist eine digitale Speisekarte zur Einsicht von Produkten, Preisen und Allergenen. Sie erhebt keine personenbezogenen Daten zu kommerziellen Zwecken und erstellt keine Nutzerprofile.",
    privacyCookieTitle: "Cookie-Richtlinie",
    privacyCookieBody: "Wir verwenden ausschließlich technische Cookies bzw. lokale Speicherung (Local Storage/Session Storage), die für den ordnungsgemäßen Betrieb der Plattform erforderlich sind (z. B. Speicherung der gewählten Sprache). Es werden keine Drittanbieter- oder Werbe-Profiling-Cookies verwendet. Kein invasives Tracking erforderlich.",
    privacyRightsTitle: "Rechte der Nutzer (DSGVO EU 2016/679)",
    privacyRightsBody: "Für Informationen zur Datensicherheit oder zum Betrieb des Dienstes können sich Gäste direkt an den Inhaber des Lokals wenden.",
    privacyClose: "Schließen",
  },
};

export function t(lang, key) {
  return (TR[lang] && TR[lang][key]) || TR.it[key] || key;
}

const CAT = {
  "caffetteria": { it: "Caffetteria", en: "Coffee Bar", es: "Cafetería", fr: "Café", de: "Kaffeebar" },
  "colazioni": { it: "Colazioni", en: "Breakfast", es: "Desayunos", fr: "Petits Déjeuners", de: "Frühstück" },
  "snack": { it: "Snack", en: "Snacks", es: "Snacks", fr: "Snacks", de: "Snacks" },
  "granite": { it: "Granite", en: "Granitas", es: "Granitas", fr: "Granitas", de: "Granitas" },
  "gelateria": { it: "Gelateria", en: "Ice Cream", es: "Heladería", fr: "Glacier", de: "Eisdiele" },
  "pasticceria": { it: "Pasticceria", en: "Pastry", es: "Pastelería", fr: "Pâtisserie", de: "Konditorei" },
  "aperitivi": { it: "Aperitivi", en: "Aperitifs", es: "Aperitivos", fr: "Apéritifs", de: "Aperitifs" },
  "liquori": { it: "Liquori", en: "Spirits", es: "Licores", fr: "Liqueurs", de: "Spirituosen" },
  "bibite": { it: "Bibite", en: "Soft Drinks", es: "Refrescos", fr: "Boissons", de: "Erfrischungsgetränke" },
  "birre": { it: "Birre", en: "Beers", es: "Cervezas", fr: "Bières", de: "Biere" },
  "cantine-siciliane": { it: "Vini e Cantine Siciliane", en: "Wines & Sicilian Wineries", es: "Vinos y Bodegas Sicilianas", fr: "Vins et Caves Siciliennes", de: "Weine & Sizilianische Weingüter" },
  "cocktail-pre-dinner": { it: "Cocktail Pre-Dinner", en: "Pre-Dinner Cocktails", es: "Cócteles Pre-Dinner", fr: "Cocktails Pre-Dinner", de: "Pre-Dinner-Cocktails" },
  "cocktail-sparkling": { it: "Cocktail Sparkling", en: "Sparkling Cocktails", es: "Cócteles Sparkling", fr: "Cocktails Sparkling", de: "Sparkling-Cocktails" },
  "cocktail-after-dinner": { it: "Cocktail After Dinner", en: "After Dinner Cocktails", es: "Cócteles After Dinner", fr: "Cocktails After Dinner", de: "After-Dinner-Cocktails" },
  "cocktail-long-drink": { it: "Cocktail Long Drink", en: "Long Drink Cocktails", es: "Cócteles Long Drink", fr: "Cocktails Long Drink", de: "Long-Drink-Cocktails" },
  "cocktail-a-tutte-le-ore": { it: "Cocktail a Tutte le Ore", en: "Anytime Cocktails", es: "Cócteles a Todas Horas", fr: "Cocktails à Toute Heure", de: "Cocktails zu jeder Stunde" },
  "cocktail-personalizzati": { it: "Cocktail Personalizzati", en: "Signature Cocktails", es: "Cócteles Personalizados", fr: "Cocktails Personnalisés", de: "Signature-Cocktails" },
};

export function catLabel(slug, lang) {
  const c = CAT[slug];
  if (!c) return slug;
  return c[lang] || c.it;
}

const SUB = {
  "Rustici": { it: "Rustici", en: "Savoury Pastries", es: "Salados", fr: "Feuilletés Salés", de: "Herzhaftes Gebäck" },
  "Insalate": { it: "Insalate", en: "Salads", es: "Ensaladas", fr: "Salades", de: "Salate" },
  "Panini": { it: "Panini", en: "Sandwiches", es: "Bocadillos", fr: "Sandwichs", de: "Sandwiches" },
  "Prodotti Singoli": { it: "Prodotti Singoli", en: "Single Items", es: "Productos Individuales", fr: "Produits à l'Unité", de: "Einzelprodukte" },
};

export function prodName(product, lang) {
  const tr = product?.translations;
  if (tr && lang && tr[lang]) return tr[lang];
  return product?.name || "";
}

export function subLabel(name, lang) {
  const s = SUB[name];
  if (!s) return name;
  return s[lang] || s.it;
}
